const NS = 'SiteFooterWidget';
const CLS = 'siteFooterWidget';

export class SiteFooterWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$siteFooterSitemap = this.$element.find('.siteFooterSitemapWidget');
		this.$siteFooterLinksWidget = this.$element.find('.siteFooterLinksWidget');

		this.$element.on('siteFooterWidget.toggleSiteFooterSitemap', () => {
			this.$siteFooterSitemap.trigger('siteFooterSitemapWidget.toggle', {});
		});

		this.$element.on('siteFooterWidget.siteFooterLinksWidget.sitemapButton.toggleClass', () => {
			this.$siteFooterLinksWidget.trigger('siteFooterLinksWidget.sitemapButton.toggleClass', {});
		});
	}
}
